import * as React from "react";

import { AddressField } from "../../../Base/Fields";

// store, state
import { constants } from "../../../../../store/apartments";
import {
  buildQueryString,
  updateActiveFormInstance,
  useFormInstanceField,
} from "../../../../../store/base";
import { useBuilding } from "../../../../../store/buildings";

import useActiveFilters from "../../../../../hooks/useActiveFilters";

import { useFilteredRealEstates } from "../../../../../store/realEstates";
import { useDispatch } from "react-redux";
import FloorSelector from "../../../Base/FieldComponents/FloorSelector";
import { useIsImpersonation } from "../../../../../store/app/hooks";
import { InnerBox } from "../../../../sharedStyles";
import {
  OverviewTitle,
  OverviewTitleWrapper,
} from "../../../../Details/OverviewInfo/styles";
import TextInputField from "src/components/Forms/Base/Fields/TextInputField";
import SelectField from "src/components/Forms/Base/Fields/SelectField";
import TableSelectField from "src/components/Forms/Base/Fields/TableSelectField";
import BuildingTable from "src/components/Tables/Buildings/FullTable";
import CompanyTable from "src/components/Tables/Companies/FullTable";
import TenantTable from "src/components/Tables/Tenants/FullTableNewVersion";

export default ({ method }) => {
  const { filteredRealEstates } = useActiveFilters();

  const isAdmin = useIsImpersonation();

  const storeName = constants.STORE_NAME;
  const dispatch = useDispatch();
  const floors = useFormInstanceField({ storeName, fieldKey: "floors" });
  const dynamicFloors = useFormInstanceField({
    storeName,
    fieldKey: "dynamic_floors",
  });
  const building = useFormInstanceField({
    storeName,
    fieldKey: "building",
  });
  const [selectedBuilding] = useBuilding(
    method === "PATCH" ? building?.id : null
  );
  const landlord = useFormInstanceField({
    storeName,
    fieldKey: "landlord",
  });
  const vacancyBookingCompany = useFormInstanceField({
    storeName,
    fieldKey: "vacancy_booking_company",
  });

  const persistantQueryString = buildQueryString({
    realestate__in: filteredRealEstates,
  });
  const persistantFilterMethod = (obj) => {
    if (!filteredRealEstates) return obj;
    return filteredRealEstates.includes(obj.realestate?.id);
  };

  const realEstateQuery = buildQueryString({
    id__in: filteredRealEstates,
  });

  const [realEstates] = useFilteredRealEstates(realEstateQuery);

  React.useEffect(() => {
    dispatch(
      updateActiveFormInstance({ storeName, data: { floors: dynamicFloors } })
    );
  }, []);

  React.useEffect(() => {
    if (landlord && !vacancyBookingCompany) {
      dispatch(
        updateActiveFormInstance({
          storeName,
          data: {
            vacancy_booking_company: landlord,
          },
        })
      );
    }
  }, [landlord]);

  return (
    <>
      <div className="grid grid-cols-2 gap-6 mb-6">
        <TextInputField
          title="Lägenhetsnummer"
          storeName={storeName}
          method={method}
          fieldKey="apartment_id"
        />
        <TextInputField
          title="Objektsnummer"
          storeName={storeName}
          method={method}
          fieldKey="premises_id"
        />
      </div>

      <AddressField
        title="Adress"
        storeName={storeName}
        method={method}
        fieldKey="address"
      />

      <FloorSelector
        storeName={storeName}
        fieldKey={"floors"}
        floors={floors}
      />

      <div className="grid grid-cols-2 gap-6 mb-6">
        <SelectField
          title="Antal RoK"
          storeName={storeName}
          method={method}
          fieldKey="category"
        />
        <TextInputField
          storeName={storeName}
          method={method}
          fieldKey="area"
          title="Area i m&sup2;"
        />

        <TableSelectField
          storeName={storeName}
          placeholder="Välj byggnad..."
          title="Byggnad"
          method={method}
          fieldKey="building"
          TableComponent={BuildingTable}
        />

        <TableSelectField
          storeName={storeName}
          placeholder="Välj hyresvärd..."
          title="Hyresvärd"
          method={method}
          fieldKey="landlord"
          TableComponent={CompanyTable}
        />

        <TableSelectField
          storeName={storeName}
          placeholder="Välj bolag för vakansbokning..."
          title="Bolag för vakansbokning"
          method={method}
          fieldKey="vacancy_booking_company"
          TableComponent={CompanyTable}
        />
      </div>

      {isAdmin && (
        <>
          <InnerBox style={{ marginBottom: 24 }}>
            <OverviewTitleWrapper>
              <OverviewTitle>Adminfunktioner</OverviewTitle>
            </OverviewTitleWrapper>

            <div className="grid grid-cols-2 gap-6 mb-6">
              <TableSelectField
                storeName={storeName}
                placeholder="Välj hyresgäst..."
                title="Hyregäst"
                method={method}
                fieldKey="tenant"
                TableComponent={TenantTable}
              />

              <TableSelectField
                storeName={storeName}
                fieldKey={"bi_tenants"}
                method={method}
                title={"Ytterligare hyresgäster"}
                placeholder={"Välj hyresgäster..."}
                isMany
                TableComponent={TenantTable}
              />
            </div>
          </InnerBox>
        </>
      )}
    </>
  );
};
